import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PolicyDescription = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #4a4a4a;
`;

export const OptionsContainer = styled.div`
  background: #f5f5f5;
  border-radius: 16px;
  margin-bottom: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OptionItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  cursor: pointer;
  border-bottom: 1px solid #d8d8d8;

  &:last-child {
    border-bottom: none;
  }
`;

export const RadioButton = styled.div<{ isSelected: boolean }>`
  width: 24px;
  height: 24px;
  border: 2px solid ${(props) => (props.isSelected ? "#008CFF" : "#757575")};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const RadioButtonDot = styled.div`
  width: 12px;
  height: 12px;
  background: #008cff;
  border-radius: 50%;
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const OptionTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
  color: #000000;
`;
